<template>
  <header ref="container" class="header-container" :class="{ hover: isHover }">
    <div class="navBox">
      <div style="
          padding-right: 50px;
          margin-right: 40px;
          height: 30px;
          border-right: 2px solid #d2d2d2;
        ">
        <img @click="toHome" class="logoImg" src="@/assets/img/qietu/zlogo2.png" alt="" />
      </div>
      <div class="nav">
        <div v-if="name.indexOf('user') === -1" class="left">
          <!-- <router-link
            :to="{
              path: '/index',
              query: { title: '首页' },
            }"
            @click.native="clearInp"
          >
            首页
          </router-link> -->
          <span @click="toHome">推荐</span>
          <router-link exact-path :to="{ path: item.path, query: { title: item.title, id: item.id } }"
            v-for="(item, index) in navList2" :key="index" @click.native="clearInp">
            {{ item.name }}
          </router-link>
          <div class="more-select" v-if="moreList.length > 0">
            <span>更多</span>
            <ul>
              <li v-for="item in moreList" :key="item.id">
                <router-link :to="{
                  path: item.path,
                  query: { title: item.title, id: item.id },
                }" @click.native="clearInp">
                  {{ item.name }}
                </router-link>
              </li>
              <!-- <li>
                <a href="https://www.tonghangpingyi.com/" target="_blank"
                  >同行评议</a
                >
              </li> -->
            </ul>
          </div>
        </div>
        <div class="go-back" v-if="name.indexOf('userpaperForm') !== -1 ||
          name.indexOf('userinformationForm') !== -1 ||
          name.indexOf('userabstractForm') !== -1 ||
          name.indexOf('userreportForm') !== -1 ||
          name.indexOf('userzghForm') !== -1 ||
          name.indexOf('usermonographForm') !== -1 ||
          name.indexOf('conferenceForm') !== -1 ||
          name.indexOf('courseForm') !== -1
          ">
          <div class="back" @click="goBack">
            <svg t="1625708753604" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
              p-id="1146" xmlns:xlink="http://www.w3.org/1999/xlink">
              <path d="M896 544H193.3312a32 32 0 1 1 0-64H896a32 32 0 0 1 0 64z" fill="#2C2C2C" p-id="1147"></path>
              <path
                d="M426.5984 798.72a31.8976 31.8976 0 0 1-22.6304-9.3696L126.8736 512 403.968 234.9056a32 32 0 0 1 45.2608 45.2608L217.3952 512l231.8336 231.8336A32 32 0 0 1 426.5984 798.72z"
                fill="#2C2C2C" p-id="1148"></path>
            </svg>
          </div>
          <div class="title">{{ $route.query.title }}发布</div>
          <div class="down" @click.stop="isDown = !isDown">
            <svg t="1625709218276" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
              p-id="1948" xmlns:xlink="http://www.w3.org/1999/xlink">
              <path
                d="M508.025406 655.446718c-14.45307 0-28.183486-5.781228-39.023289-15.898376l-231.249118-231.249118c-10.117149-10.117149-10.117149-26.015526 0-36.132675s26.015526-10.117149 36.132675 0l231.249118 231.249118c2.16796 2.16796 4.335921 2.16796 5.781228 0l231.971771-231.971771c10.117149-10.117149 26.015526-10.117149 35.410021 0 10.117149 10.117149 10.117149 26.015526 0 36.132674l-231.971771 231.971772c-9.394495 10.117149-23.124912 15.898377-38.300635 15.898376z"
                p-id="1949"></path>
            </svg>
          </div>
          <ul class="down-list" v-if="isDown">
            <li v-for="(v, i) in downLists" :key="i" @click="goForm(v)">
              {{ v.name }}发布
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="search-container" v-if="name !== 'index'">
        <div class="search">
          <div class="inp">
            <input type="text" placeholder="请输入期刊/文献标题进行搜索" v-model="inpText" @keydown.enter="hideMessage" />
            <input type="text" style="width: 0; opacity: 0; border: none" />
          </div>
        </div>
        <Icon type="md-search" class="icon-search" size="18" @click="hideMessage" />
      </div>
      <div class="toRelease" @click="toRelease">
        <img @click.stop="toRelease" src="@/assets/img/qietu/release.png" alt="" />发布
        <ul class="releaseSelect" v-show="releaseShow">
          <li v-for="(item, i) in downLists" :key="i">
            <router-link :to="{ path: item.path, query: { title: item.name } }">{{ item.name }}
            </router-link>
          </li>
        </ul>
      </div>
      <!-- 商城按钮 原引导H5 @click="toH5Mall"  现点击跳转2.0商城-->
      <div class="mall" @click="bookMallPC">
        <img src="@/assets/img/qietu/shop.png" alt="查看学术商城">
        <span>商城</span>
        <!-- <div v-show="showQrcode" class="qrcode-area">
          <p>扫码后在手机端查看商城</p>
          <div style="width:150px;margin:0 auto;">
            <div id="qrcodeArea"></div>
          </div>

        </div> -->

      </div>
      <div v-if="token === ''" class="btn">
        <span @click="register">注册</span>
        <span class="bar">|</span>
        <span @click="login">登录</span>
      </div>
      <div v-else class="login">
        <Dropdown @on-click="userClick">
          <div>
            <img v-if="userInfo.headPhoto" v-lazy="userInfo.headPhoto
              ? $global.imgUrl + userInfo.headPhoto
              : '@/assets/img/login/4.png'
              " alt="" />
            <img v-else src="@/assets/img/login/4.png" alt="" />
            <span class="name">{{
              isSonUser === "true"
              ? userInfo.account.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2")
              : userInfo.user.customerType === 1
                ? userInfo.account.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2")
                : userInfo.user.customerType === 2
                  ? userInfo.name
                  : userInfo.companyName
            }}</span>
          </div>
          <DropdownMenu slot="list">
            <DropdownItem name="goUserCenter">用户中心</DropdownItem>
            <DropdownItem name="logOut">退出</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
      <!-- <div class="learn">
        <img src="@/assets/img/qietu/learn.png" alt="" />
      </div> -->
      <!-- <router-link
        to="/user"
        class="authentication-btn"
        v-if="
          hasLogin &&
          userInfo.user.customerType === 1 &&
          name.indexOf('user') !== -1
        "
        >认证未完成&gt;
      </router-link> -->
    </div>
    <Modal v-model="alert" :scrollable="true" width="572px" class-name="my-center-modal" :footer-hide="true">
      <div class="content">
        <p v-if="sonUser === 1">
          <span v-if="act === 1">欢迎登录中文知识网</span>
          <span v-else-if="act === 2">忘记密码</span>
          <span v-else-if="act === 0">欢迎注册中文知识网</span>
        </p>
        <p v-else>子账号登录</p>
        <Contents :sonUser="sonUser" @cahngeAct="cahngeAct" @changeAlert="changeAlert" :act="act"></Contents>
        <Footers @SetsonUser="SetsonUser" @cahngeAct="cahngeAct" :sonUser="sonUser" :act="act"></Footers>
      </div>
    </Modal>
    <AuthenticationModel v-if="isFlag" @handleClose="isFlag = false"></AuthenticationModel>
  </header>
</template>

<script>
// import Top from "./components/top";
import Contents from "./components/contents";
import Footers from "./components/footers";
import AuthenticationModel from "../user/components/AuthenticationModel.vue";
import { mapState } from "vuex";
import QRCode from "qrcodejs2";

export default {
  components: {
    // Top,
    Contents,
    Footers,
    AuthenticationModel,
  },
  computed: {
    ...mapState(["token", "userInfo", "hasLogin"]),
    downLists() {
      let arr = [];
      this.downList.forEach((item) => {
        if (item.name === this.$route.query.title) {
          return;
        } else {
          switch (item.name) {
            case "资讯":
              arr.push({
                name: item.name,
                path: "/informationForm",
              });
              break;
            case "论文":
              arr.push({
                name: item.name,
                path: "/paperForm",
              });
              break;
            case "文摘":
              arr.push({
                name: item.name,
                path: "/abstractForm",
              });
              break;
            case "报告":
              arr.push({
                name: item.name,
                path: "/reportForm",
              });
              break;
            case "专著":
              arr.push({
                name: item.name,
                path: "/monographForm",
              });
              break;
            case "征稿函":
              arr.push({
                name: item.name,
                path: "/zghForm",
              });
              break;
            case "会议":
              arr.push({
                name: item.name,
                path: "/conferenceForm",
              });
              break;
            // case "课程":
            //   arr.push({
            //     name: item.name,
            //     path: "/courseForm",
            //   });
            //   break;
          }
        }
      });
      return arr;
    },
    isSonUser() {
      return sessionStorage.getItem("isSon");
    },
  },
  data() {
    return {
      screenWidth: document.body.clientWidth,
      inpText: "",
      isShow: false,
      isHover: false,
      isMessage: true,
      isDown: false,
      releaseShow: false,
      flag: false,
      isFlag: false,
      name: "",
      downList: [],
      navList: [
        {
          name: "中文资讯",
          title: "中文资讯",
          path: "/zwzx",
          id: 1,
        },
        {
          name: "中文视讯",
          title: "中文视讯",
          path: "/zwsx",
          id: 2,
        },
        {
          name: "学术精汇",
          title: "学术精汇",
          path: "/xsjh",
          id: 3,
        },
        {
          name: "百科精选",
          title: "百科精选",
          path: "/bkjx",
          id: 4,
        },
        {
          name: "学术综述",
          title: "学术综述",
          path: "/xszs",
          id: 5,
        },
        {
          name: "学术专著",
          title: "学术专著",
          path: "/xszz",
          id: 6,
        },
        {
          name: "万商数据",
          title: "万商数据",
          path: "/wssj",
          id: 7,
        },
        {
          name: "百家在线精选",
          title: "百家在线",
          path: "/bjzx",
          id: 8,
        },
        {
          name: "百科在线精选",
          title: "百科在线",
          path: "/bkzx",
          id: 9,
        },
        {
          name: "作者服务",
          title: "作者服务",
          path: "/zgq",
          id: 11,
        },
        {
          name: "学术会议",
          title: "学术会议",
          path: "/xshy",
          id: 14,
        },

        {
          name: "教育培训",
          title: "教育培训",
          path: "/jypx",
          id: 15,
        },
      ],
      navList1: [],
      navList2: [],
      moreList: [],
      alert: false,
      act: 1,
      navType: true,
      sonUser: 1,
      // 商城二维码是否显示
      showQrcode: false
    };
  },
  created() {
    this.getNavList();
  },
  mounted() {
    this.$bus.$on("mainScroll", this.handleScroll);
    this.$bus.$on("mainDocument", this.handleDocument);
    this.$bus.$on("showModel", this.showModel);
    this.name = this.$router.history.current.name;
    if (sessionStorage.getItem("userInfo")) {
      this.downList = JSON.parse(sessionStorage.getItem("userInfo"))
        .permissionUrls[9]
        ? JSON.parse(sessionStorage.getItem("userInfo")).permissionUrls[9]
        : [];
    }
    // 监听屏幕宽度
    const that = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
      })();
    };
  },
  beforeDestroy() {
    this.$bus.$off("mainScroll", this.handleScroll);
    this.$bus.$off("mainDocument", this.handleDocument);
    this.$bus.$off("showModel", this.showModel);
  },
  watch: {
    $route: {
      handler(val) {
        this.name = val.name;
        // console.log(val);//新路由信息
        // console.log(oldval);//老路由信息
      },
      // 深度观察监听
      deep: true,
    },
    // 监听页面宽度变化改变nav标签数量
    screenWidth(val) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenWidth = val;
        this.timer = true;
        let that = this;
        setTimeout(function () {
          // 根据宽度限制nav标签数量
          let num =
            that.screenWidth > 1500 ? 7 : that.screenWidth < 1260 ? 3 : 4;
          that.navList2 = [...that.navList1];
          if (that.navList2.length > num) {
            that.moreList = that.navList2.splice(num);
          }
          that.timer = false;
        }, 400);
      }
    },
  },
  methods: {
    toHome() {
      // 跳转静态页面首页
      window.location.href = this.$global.SeoUrl;
    },
    toRelease() {
      if (!this.hasLogin) {
        this.$bus.$emit("showModel", true);
      } else if (
        !JSON.parse(sessionStorage.getItem("userInfo")).permissionUrls[9]
      ) {
        this.isFlag = true;
        this.flag = false;
      } else {
        if (sessionStorage.getItem("userInfo")) {
          this.downList = JSON.parse(sessionStorage.getItem("userInfo"))
            .permissionUrls[9]
            ? JSON.parse(sessionStorage.getItem("userInfo")).permissionUrls[9]
            : [];
        }
        this.releaseShow = !this.releaseShow;
      }
    },
    async getNavList() {
      const resp = await this.$apis.searchServe.getNavList();
      resp.data.forEach((item) => {
        this.navList.forEach((i) => {
          if (i.id == item.id) {
            i.name = item.columnName;
            this.navList1.push(i);
          }
        });
      });
      // 根据宽度限制nav标签数量
      let num = this.screenWidth > 1500 ? 7 : this.screenWidth < 1260 ? 3 : 4;
      this.navList2 = [...this.navList1];
      if (this.navList2.length > num) {
        this.moreList = this.navList2.splice(num);
      }
    },
    clearInp() {
      this.inpText = ""; //清空搜索框数据
    },
    showModel(flag) {
      this.alert = flag;
    },
    goForm(item) {
      this.$router.push({
        path: item.path,
        query: {
          title: item.name,
        },
      });
      this.isDown = false;
    },
    SetsonUser(e) {
      this.sonUser = e;
    },
    goBack() {
      // window.history.back();
      this.$router.push("/user");
    },
    userClick(e) {
      //e是事件名字直接调用
      this[e]();
    },
    goUserCenter() {
      window.open("/admin/user", "_blank");
    },
    async logOut() {
      await this.$apis.loginServe.logOut();
      this.$store.commit("logOut");
      this.$Message.success("退出成功");
    },
    changeAlert(e) {
      this.alert = e;
    },
    cahngeAct(e) {
      this.act = e;
    },
    register() {
      this.alert = true;
      this.act = 0;
      this.sonUser = 1;
    },
    login() {
      this.alert = true;
      this.act = 1;
    },
    handleScroll() {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      if (top > this.$refs.container.clientHeight) {
        this.isHover = true;
      } else {
        this.isHover = false;
      }
    },
    handleDocument(e) {
      if (
        e.target.tagName !== "INPUT" &&
        e.target.className !== "message" &&
        e.target.className !== "toRelease"
      ) {
        this.isMessage = true;
        this.isShow = false;
        this.releaseShow = false;
      }
    },
    hideMessage() {
      this.isMessage = true;
      let searchType = "title";
      if (this.inpText === "") {
        return;
      }
      if (sessionStorage.getItem("InputAndActiveType")) {
        // 是否在搜索页面进行头部搜索
        let type = sessionStorage.getItem("InputAndActiveType");
        if (type == 1 || type == 3 || type == 4 || type == 22) {
          searchType = "name";
        }
      }
      // 存放搜索结果得值
      this.$router.push({
        path: "/search",
        query: {
          paramStr: this.inpText,
          searchType,
          title: "标题",
        },
      });
      // let Intval = encodeURIComponent(this.inpText)
      // let aa = Intval.replace(/\(/g, '%28')
      // let bb = aa.replace(/\)/g, '%29')
      // let cc = bb.replace(/\*/g, '%2a')
      // console.log(Intval);
      // window.open(`http://localhost:8080/admin/search?&paramStr=${cc}&token=`);
    },
    // 导航新增商城按钮，点击弹出二维码，引导至H5
    toH5Mall() {
      this.showQrcode = !this.showQrcode;
      if (this.showQrcode && !this.qr) {
        let routeUrl = this.$router.resolve({
          path: "bookMall",
        });
        this.$nextTick(() => {
          // 生成H5
          this.qr = new QRCode("qrcodeArea", {
            width: 150,
            height: 150, // 高度
            text: location.protocol+'//'+location.hostname + routeUrl.href // 二维码内容
          });
        })
      }

    },
    // 跳转2.0商城
    bookMallPC() { 
      location.href = this.$global.SeoUrl + "/list/books"
    },
  },
};
</script>

<style lang="scss">
.my-center-modal {
  .ivu-modal-body {
    //padding: 0px;
    padding-left: 0px;
    padding-right: 0px;
  }

  .ivu-modal {
    top: 0px !important;
  }

  .content {
    p {
      margin-top: 80px;
      text-align: center;
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #333333;
    }
  }
}
</style>
<style scoped lang="scss">
::v-deep .ivu-select-dropdown {
  z-index: 9999999999;
}

.header-container {
  box-sizing: border-box;
  box-shadow: 0px 7px 15px 1px rgba(6, 10, 82, 0.09);
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  top: 0;
  left: 0;
  padding: 0 2%;
  width: 100%;
  min-width: 1280px;
  height: 105px;
  background-color: #ffffff;
  user-select: none;
  z-index: 999;

  .navBox {
    width: 60%;
    display: flex;
    align-items: center;

    .logoImg {
      flex-shrink: 0;
      width: 50px;
      height: 30px;
      margin-right: 3%;
      cursor: pointer;
    }

    .nav {
      // display: flex;
      // justify-content: space-between;
      width: calc(100% - 132px);
      position: relative;

      // width: 725px;
      .go-back {
        width: 150px;
        display: flex;
        margin-left: 46px;
        cursor: pointer;

        // position: absolute;
        // left: 0;
        // top: 0px;
        .title {
          font-size: 12px;
          color: #333333;
          margin: 0 10px;
        }

        .back {
          svg {
            width: 19px;
            height: 13px;
          }
        }

        .down {
          svg {
            width: 12px;
            height: 12px;
          }
        }

        .down-list {
          position: absolute;
          // left: 0;
          top: 20px;
          width: 100px;
          background-color: #fff;
          box-shadow: 0px 7px 15px 1px rgb(22 26 100 / 13%);
          z-index: 99999;

          li {
            padding: 5px;
            text-align: center;
            font-size: 12px;
          }
        }
      }

      .left {
        position: relative;
        width: 100%;
        height: 21px;
        font-size: 16px;
        list-style: none;

        span {
          margin-right: 2%;
          color: #333333;
          cursor: pointer;
          text-align: center;
          white-space: nowrap;
        }

        .more-select {
          position: relative;
          display: inline-block;
          cursor: pointer;

          &:hover ul {
            display: block;

            a {
              margin-right: 3% !important;
            }
          }

          ul {
            position: absolute;
            right: -50px;
            top: 24px;
            text-align: center;

            display: none;
            z-index: 999;
            background-color: #ffffff;
            box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.1);

            &:hover {
              display: block;
            }

            li {
              padding: 10px 20px;

              &:hover {
                a {
                  // margin-right: 10px;
                  color: #72aacb;
                  font-weight: bold;
                }
              }
            }
          }
        }

        .more-select:hover {
          ul {
            display: block;
          }
        }

        a {
          margin-right: 2%;
          color: #333333;
          cursor: pointer;
          text-align: center;
          white-space: nowrap;

          &.router-link-active {
            font-size: 16px;
            color: #72aacb;
            font-weight: bold;
          }
        }
      }
    }
  }

  .right {
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .search-container {
      width: 55%;
      position: relative;
      margin-right: 3%;

      .search {
        width: 100%;
        height: 51px;

        .inp {
          width: 100%;
          height: 100%;
          border-radius: 25px;
          background-color: #fff;
          border: 1px solid #b5b5b5;

          input {
            width: 100%;
            height: 100%;
            border: none;
            outline: none;
            background-color: transparent;
            font-size: 14px;
            font-weight: 400;
            color: #666666;
            padding: 0 30px 0 20px;
          }
        }
      }

      .icon-search {
        position: absolute;
        right: 10px;
        top: 16px;
        width: 17px;
        height: 18px;
        cursor: pointer;
        color: #000000;
        z-index: 1;
      }
    }

    .toRelease {
      width: 75px;
      position: relative;
      margin-right: 3%;
      line-height: 60px;
      cursor: pointer;
      font-size: 16px;
      color: #333333;

      img {
        margin-right: 12px;
        width: 29px;
        height: 29px;
        vertical-align: middle;
      }

      .releaseSelect {
        position: absolute;
        right: -30px;
        top: 60px;
        width: 120px;
        text-align: center;
        background-color: #fff;

        li {
          a {
            display: block;
            font-size: 16px;
            color: #333333;
          }

          &:hover {
            background: #f3f3f3;
          }
        }
      }
    }

    // 商城
    .mall {
      margin-right: 3%;
      line-height: 60px;
      cursor: pointer;
      position: relative;

      img {
        width: 28px;
        height: 28px;
        vertical-align: middle;
        margin-right: 10px;

      }

      // 二维码区域
      .qrcode-area {
        position: absolute;
        width: 220px;
        height: 200px;
        top: 60px;
        left: -50%;
        background: #fff;
        // transform: translateX(50%);
        border: red;
        // display: none;
        line-height: 16px;

        p {
          color: #000;
          font-weight: 700;
          margin-bottom: 10px;
          text-align: center;
        }

      }
    }

    .authentication-btn {
      width: 100px;
      line-height: 30px;
      border-radius: 20px;
      font-size: 12px;
      cursor: pointer;
      height: 30px;
      background-color: #263d78;
      color: #fff;
      text-align: center;
    }

    .learn {
      width: 37px;
      height: 61px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .login {
      //height: 16px;
      // text-align: center;
      // margin: 0 33px 0 16px;
      cursor: pointer;

      //background: pink;
      //display: flex;
      //position: relative;
      //align-items: center;
      div {
        display: flex;
      }

      img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
      }

      .name {
        margin-left: 8px;
        width: 100px;
        line-height: 40px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        text-align: left;
        font-size: 14px;
        color: #404040;
      }
    }

    .btn {
      margin-right: 2%;
      text-align: center;
      cursor: pointer;

      a {
        color: #404040;
        font-size: 14px;
      }

      .bar {
        margin: 0 7px;
      }
    }
  }
}

//::v-deep .ivu-modal-wrap {
//  overflow: hidden;
//}
::v-deep .my-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal-body {
    .ivu-modal-body {
      padding: 0;
    }

    // .ivu-modal {
    //   //top: 10px;
    //   //top: 0 !important;
    // }
  }
}
</style>
